export function returnOrderInfoById(state) {
  return (orderId) => {
    return state.detail[orderId] ? state.detail[orderId] : {}
  }
}

export const returnReason = (state) => state.reasons
